const styles = ({ screenSizes, spacing, typography }) => ({
  ...typography.p,
  ...typography.p1,
  margin: [spacing.lg, 0, 0, 0],
  textAlign: 'center',
  [`@media(min-width: ${screenSizes.mobileMax}px)`]: {
    fontSize: typography.p1.desktopFontSize,
  },
});

export default styles;
